import React from 'react';

export function FormasPagoDetalleList({ formasPago, titulo, loading, error, formatFecha }) {
  const fmt = formatFecha || ((f) => (f ? String(f).slice(0, 10) : '-'));

  if (loading) {
    return <p style={{ color: '#7f8c8d', margin: '8px 0' }}>Cargando formas de pago...</p>;
  }
  if (error) {
    return <p style={{ color: '#c0392b', margin: '8px 0', fontSize: '14px' }}>{error}</p>;
  }
  if (!formasPago?.length) {
    return null;
  }

  return (
    <div style={{ marginTop: titulo ? '8px' : 0 }}>
      {titulo && (
        <strong style={{ display: 'block', marginBottom: '8px' }}>{titulo}</strong>
      )}
      <ul style={{ margin: 0, paddingLeft: '20px' }}>
        {formasPago.map((fp, idx) => (
          <li key={fp.id || idx} style={{ marginBottom: '8px' }}>
            <strong>{fp.forma_pago_nombre}</strong>: ${parseFloat(fp.monto || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}
            {fp.cheque_propio && (
              <span style={{ display: 'block', fontSize: '12px', color: '#555', marginTop: '4px' }}>
                Nº {fp.cheque_propio.numero} · F. emisión {fmt(fp.cheque_propio.fecha_emision)}
                {fp.cheque_propio.cuenta_banco_nombre ? ` · ${fp.cheque_propio.cuenta_banco_nombre}` : ''}
                {fp.cheque_propio.cuenta_numero ? ` ${fp.cheque_propio.cuenta_numero}` : ''}
                {' · '}{fp.cheque_propio.es_electronico ? 'Electrónico' : 'Papel'}
              </span>
            )}
            {fp.cheque && !fp.cheque_propio && (
              <span style={{ display: 'block', fontSize: '12px', color: '#555', marginTop: '4px' }}>
                Banco {fp.cheque.banco_nombre} · Nº {fp.cheque.numero_cheque} · Titular {fp.cheque.titular}
              </span>
            )}
            {fp.cheques_cartera?.map((ch) => (
              <span key={ch.id} style={{ display: 'block', fontSize: '12px', color: '#555', marginTop: '4px' }}>
                Cheque Nº {ch.numero} · ${parseFloat(ch.importe || 0).toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                {ch.banco_nombre ? ` · ${ch.banco_nombre}` : ''}
                {ch.cliente_razon_social ? ` · ${ch.cliente_razon_social}` : ''}
                {ch.fecha_cobro ? ` · F. cobro ${fmt(ch.fecha_cobro)}` : ''}
              </span>
            ))}
            {fp.transferencia && (
              <span style={{ display: 'block', fontSize: '12px', color: '#555', marginTop: '4px' }}>
                Cuenta {fp.transferencia.numero_cuenta} · {fp.transferencia.banco_nombre} · Fecha {fmt(fp.transferencia.fecha)}
              </span>
            )}
            {fp.tarjeta && (
              <span style={{ display: 'block', fontSize: '12px', color: '#555', marginTop: '4px' }}>
                Ticket Nº {fp.tarjeta.numero_ticket}
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
